import _ from 'lodash'
import Vue from 'vue'
export default {
    install(Vue) {
        Vue.prototype._ = _

    }
};